export const INITIALIZE_POSTS = 'INITIALIZE_POSTS';
export const CREATE_NEW_POST = 'CREATE_NEW_POST';
export const SET_POST_TO_EDIT = 'SET_POST_TO_EDIT';
export const UPDATE_POST = 'UPDATE_POST';
export const DELETE_POST = 'DELETE_POST';
export const LIKE_POST = 'LIKE_POST';
